import { useHomeConfig } from 'services/home-config/useHomeConfig'

type FooterSettings = {
  privacyPolicyUrl: string | null
  termsUrl: string | null
  helpUrl: string | null
}

export const useBiblionFooterSettings = (enabled: boolean): FooterSettings => {
  const { config } = useHomeConfig(enabled)

  return {
    privacyPolicyUrl: config.settings.privacy_policy_url || null,
    termsUrl: config.settings.terms_url || null,
    helpUrl: config.settings.help_url || null
  }
}
